'use client'
import { __cUserService } from '@/services/client/__c.user.service'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { deleteCookie, getCookie } from 'cookies-next/client'
import { useRouter } from 'next/navigation'

export const useUserQuery = () => {
  return useQuery({
    queryKey: ['user'],
    queryFn: async () => {
      try {
        const accessToken = await getCookie(process.env.NEXT_PUBLIC_TOKEN_KEY)
        if (!accessToken) {
          return null
        }
        const res = await __cUserService.getCurrentUser(accessToken)
        return res
      } catch (error) {
        console.error('🧙 ~ error:', error)
        deleteCookie(process.env.NEXT_PUBLIC_TOKEN_KEY)
        return null
      }
    },
    staleTime: Infinity,
    notifyOnChangeProps: 'all',
  })
}

export const useRefreshAfterLogin = () => {
  const queryClient = useQueryClient()
  const router = useRouter()
  const { refetch: refetchUser } = useUserQuery()

  return () => {
    router.refresh()
    refetchUser()
    // queryClient.invalidateQueries()
    queryClient.refetchQueries()
  }
}

export const useIsLoggedIn = () => {
  const { data } = useUserQuery()
  return !!data
}
